import Nullstack from 'nullstack';
export default function IconSunMoon({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-sun-moon",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M9.173 14.83a4 4 0 1 1 5.657 -5.657"
  }), "   ", Nullstack.element("path", {
    d: "M11.294 12.707l.174 .247a7.5 7.5 0 0 0 8.845 2.492a9 9 0 0 1 -14.671 2.914"
  }), "   ", Nullstack.element("path", {
    d: "M3 12h1"
  }), "   ", Nullstack.element("path", {
    d: "M12 3v1"
  }), "   ", Nullstack.element("path", {
    d: "M5.6 5.6l.7 .7"
  }), "   ", Nullstack.element("path", {
    d: "M3 21l18 -18"
  }), " ");
}